module.exports = __webpack_public_path__ + "static/media/freeMarketAdvantage2.f0912fea.svg";